import { MenuBulletHorizontal } from '@zoomit/icons';
import { Skeleton } from '@zoomit/primitives';
import { cssVar, theme } from '@zoomit/zoomit-ds';

const ProductListItemMobileSkeleton = () => {
  return (
    <div className="bg-card relative flex w-full flex-nowrap items-center gap-2 rounded-sm shadow">
      <Skeleton variant="rectangular" width={12.8} className="aspect-square" />
      <div className="flex h-32 flex-col flex-nowrap items-start justify-between gap-2 p-2">
        <div className="flex flex-col gap-3">
          <div className="flex gap-0.5">
            <Skeleton variant="text" width={1} />
            <Skeleton variant="text" width={2} />
          </div>
          <Skeleton variant="text" width={7} />
        </div>
        <Skeleton variant="text" width={11} />
      </div>
      <div className="absolute top-3 left-3">
        <MenuBulletHorizontal fill={cssVar(theme.grey3)} />
      </div>
    </div>
  );
};

export default ProductListItemMobileSkeleton;
